export default __webpack_public_path__ + "static/media/1516 knife block A side.368c5adc.png";